import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner-native";

import { useTranslator } from "@/hooks/useTranslate";

import { WorkRequirementsApi } from "../api/workRequirementsApi";

export const WorkRequirementsQueryKeys = {
  all: ["workRequirements"] as const,
  list: () => [...WorkRequirementsQueryKeys.all, "list"] as const,
  details: (workRequirementId: string) =>
    [...WorkRequirementsQueryKeys.all, "details", workRequirementId] as const,
};

export const useListWorkRequirementsQuery = () => {
  return useQuery({
    queryKey: WorkRequirementsQueryKeys.list(),
    queryFn: () => WorkRequirementsApi.listWorkRequirements(),
  });
};

export const useGetWorkRequirementQuery = (workRequirementId: string) => {
  const { t } = useTranslator();

  const query = useQuery({
    queryKey: WorkRequirementsQueryKeys.details(workRequirementId),
    queryFn: () => WorkRequirementsApi.getWorkRequirement(workRequirementId),
    enabled: Boolean(workRequirementId),
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(t("common:errors.unknown"), {
        id: `work-requirement-error-${workRequirementId}`,
      });
    }
  }, [query.isError, workRequirementId, t]);

  return query;
};
